import { BasketProductValue, PromotionType, UserInfo } from '../../../../src';
import { freeShippingBusinessRules } from '../shipping';

type BasketBusinessRulesProps = {
    products: BasketProductValue[];
    productsCount: number;
    totalBeforeDiscount?: number;
    totalForFreeShipping: number;
    userInfo?: UserInfo;
};
export const BasketBusinessRules = ({
    products,
    productsCount,
    totalBeforeDiscount,
    totalForFreeShipping,
    userInfo,
}: BasketBusinessRulesProps) => {
    const productsWithoutBonus = products.filter((product) => !product.isBonus);
    const productsDisplayed = productsWithoutBonus.reverse().slice(0, 3);

    const quantityOfProductsDisplayed = productsDisplayed.reduce((quantity, product) => quantity + product.quantity, 0);

    const quantityOfProductsNotDisplayed = productsCount - quantityOfProductsDisplayed;

    const isFreeShipping = freeShippingBusinessRules({
        price: totalBeforeDiscount,
        threshold: totalForFreeShipping,
        userInfo,
    });

    const hasOmnibusProduct = products.some((product) => product.promotion === PromotionType.OMNIBUS_NEGATIVE);

    return {
        productsDisplayed,
        quantityOfProductsNotDisplayed,
        isFreeShipping,
        hasOmnibusProduct,
    };
};
